export var normalizedErrors = function (errors) {
    var errMap = {};
    errors.forEach(function (err) {
        errMap[err.path] = err.message;
    });
    return errMap;
};
//# sourceMappingURL=normalizedErrors.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/util/normalizedErrors.js
// module id = 56
// module chunks = 0